import React from 'react';
import { translate } from 'react-i18next';

class AccountMobileApps extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const user = Utils.getCoreUser();
    return (
      <div className={this.props.activeState}>
        <div className="account-mobile-apps">
          <h1>{this.props.t('AccountMobileApps.mobile_apps')}</h1>

          {window.EmployeeWeb.ENVConfig.show_brand == 'true' && (
            <div className="mobile-app">
              <img
                src={window.EmployeeWeb.ENVConfig.brand_icon}
                alt={window.EmployeeWeb.ENVConfig.brand_name}
              />
              <h3>{window.EmployeeWeb.ENVConfig.brand_name}</h3>
              <p>
                {this.props.t(
                  'brandConfig.brand_product_description',
                  { product: window.EmployeeWeb.ENVConfig.brand_name }
                )}
              </p>
              <a
                target="_blank"
                href={window.EmployeeWeb.ENVConfig.brand_android_link}
                className="button button--recommended button--inline"
              >
                {this.props.t('AccountMobileApps.download_for_android')}
              </a>
              <a
                target="_blank"
                href={window.EmployeeWeb.ENVConfig.brand_ios_link}
                className="button button--recommended button--inline"
              >
                {this.props.t('AccountMobileApps.download_for_ios')}
              </a>
            </div>
          )}

          {window.EmployeeWeb.ENVConfig.show_live_brand == 'true' && (
            <div className="mobile-app">
              <img
                src={window.EmployeeWeb.ENVConfig.live_brand_icon}
                alt={window.EmployeeWeb.ENVConfig.live_brand_name}
              />
              <h3>{window.EmployeeWeb.ENVConfig.live_brand_name}</h3>
              <p>
                {this.props.t(
                  (user.company && user.company.time_and_attendance) 
                    ? 'brandConfig.live_brand_product_description'
                    : 'brandConfig.live_brand_alt_product_description', 
                  { product: window.EmployeeWeb.ENVConfig.live_brand_name }
                )}
              </p>
              <a
                target="_blank"
                href={window.EmployeeWeb.ENVConfig.live_brand_android_link}
                className="button button--recommended button--inline"
              >
                {this.props.t('AccountMobileApps.download_for_android')}
              </a>
              <a
                target="_blank"
                href={window.EmployeeWeb.ENVConfig.live_brand_ios_link}
                className="button button--recommended button--inline"
              >
                {this.props.t('AccountMobileApps.download_for_ios')}
              </a>
            </div>
          )}

          {window.EmployeeWeb.ENVConfig.show_connect_brand == 'true' && (
            <div className="mobile-app">
              <img
                src={window.EmployeeWeb.ENVConfig.connect_brand_icon}
                alt={window.EmployeeWeb.ENVConfig.connect_brand_name}
              />
              <h3>{window.EmployeeWeb.ENVConfig.connect_brand_name}</h3>
              <p>
                {this.props.t(
                  'brandConfig.connect_brand_product_description',
                  { product: window.EmployeeWeb.ENVConfig.connect_brand_name }
                )}
              </p>
              <a
                target="_blank"
                href={window.EmployeeWeb.ENVConfig.connect_brand_android_link}
                className="button button--recommended button--inline"
              >
                {this.props.t('AccountMobileApps.download_for_android')}
              </a>
              <a
                target="_blank"
                href={window.EmployeeWeb.ENVConfig.connect_brand_ios_link}
                className="button button--recommended button--inline"
              >
                {this.props.t('AccountMobileApps.download_for_ios')}
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default translate()(AccountMobileApps);
